// extracted by mini-css-extract-plugin
module.exports = {"createPasswordWrap":"style_createPasswordWrap__DTnWd","password":"style_password__nniE2","changePassword":"style_changePassword__G1JGR"};